export const moduleType = {
    Admin : 1,
    Login : 2,
    Public : 3
}